interface IArrowIcon {
  width: number | string;
  height: number;
}

const ArrowIcon = ({ width, height }: IArrowIcon) => {
  // rendering arrow icon component here
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 254 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 13C0.895431 13 9.65645e-08 13.8954 0 15C-9.65645e-08 16.1046 0.89543 17 2 17L2 13ZM253.414 16.4142C254.195 15.6332 254.195 14.3669 253.414 13.5858L240.686 0.857885C239.905 0.0768366 238.639 0.0768365 237.858 0.857885C237.077 1.63893 237.077 2.90526 237.858 3.68631L249.172 15L237.858 26.3137C237.077 27.0948 237.077 28.3611 237.858 29.1422C238.639 29.9232 239.905 29.9232 240.686 29.1422L253.414 16.4142ZM2 17L252 17L252 13L2 13L2 17Z"
        fill="white"
      />
    </svg>
  );
};

export default ArrowIcon;
